import _get from 'lodash/get'
import _map from 'lodash/map'

export const eventAlternativeViewAdapter = alternativeViews =>
  _map(alternativeViews, el => ({ id: el.id, ..._get(el, 'attributes', {}) }))
